import { ErrorInfo, PropsWithChildren, PureComponent } from 'react'

import { getUrlParam } from 'core-components/helpers/url'
import { getAppId } from 'src/core/classes/helpers/getAppId'
import { IErrorLogs } from 'src/core/classes/models/IErrorLogs'
import { CrudStoreItemCore } from 'src/core/classes/services/InitializationServiceCore'
import { CORE_FORM } from 'src/core/constants'
import { CrudStore } from 'src/core/types/crudStore'

import { ViewError } from './Error'
import {
  handleChunkError,
  isChunkFailedMessage,
} from './errorBoundary/helpers/isChunkFailedMessage'

export interface Props extends PropsWithChildren {
  errorView?: any
}
interface State {
  error: null | Error
  errorInfo: null | ErrorInfo
  hasError: boolean
}

export class ErrorBoundary extends PureComponent<Props, State> {
  public state: State = {
    error: null,
    errorInfo: null,
    hasError: false,
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (isChunkFailedMessage(error?.message)) {
      return handleChunkError(error.message)
    }

    if (!error) {
      this.setState({ hasError: true })
    } else {
      this.setState({ error, errorInfo, hasError: true })
    }

    this.sendLogs(error, errorInfo)
  }

  public render() {
    const { errorView, children } = this.props
    const { hasError } = this.state

    return hasError ? errorView || this.renderDefaultError() : children
  }

  private renderDefaultError = () => {
    return <ViewError />
  }

  private sendLogs = (error: Error, errorInfo: ErrorInfo) => {
    const source = CrudStore.get(CrudStoreItemCore.ErrorLogs)
    const rawStack = errorInfo?.componentStack || error?.stack || ''
    const stack = rawStack
      .replace('\n', '')
      .replaceAll(window.location.origin, '')
      .replaceAll('  ', '')
      .replaceAll('<anonymous>', 'anonymous')
    const page = window.location.pathname + window.location.search

    const logItem: IErrorLogs = {
      AppId: getAppId(),
      ErrorMessage: error?.message,
      ErrorStack: stack,
      Page: page,
      EntryId: -1,
    }

    source.create(CORE_FORM.errorLogs.id, [logItem])
  }
}

export default ErrorBoundary
